module.exports = __webpack_public_path__ + "img/notificare-portocaliu.7cde2089.svg";